import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { get_generic, put_generic } from "../../../services/http_operations";
import { ReplaceUnderscores } from "../../../services/misc_functions";
import { calculateAggregatedKPI } from "../../../services/operation_tool_services";
export default function ViewAggregatedKPIPage() {
  //state definitions
  const [deviceNames, setDeviceNames] = useState(null);
  const [devices, setDevices] = useState(null);
  const [tableRows, setTableRows] = useState(null);

  const deviceSelectRef = useRef(null);
  //message for user
  useEffect(() => {
    const fetchdata = async () => {
      const devicesRes = await get_generic("devices", {
        limit: -1,
        select: ["_id", "features"],
      });

      const _deviceNames = devicesRes.docs.map((d) => d._id).reverse();
      setDeviceNames(_deviceNames);
      setDevices(devicesRes.docs);
    };
    fetchdata();
  }, []);

  //callbacks
  const handleSelectChange = async () => {
    const selectedDevice = deviceSelectRef.current.value;
    const measurementsRes = await get_generic("measurements", {
      limit: -1,
      filter: JSON.stringify({ device: selectedDevice }),
    });
    const featuresRes = await get_generic("features", {
      limit: -1,
    });
    const _features = featuresRes.docs;
    const deviceFeatures = _features.filter(
      (f) =>
        devices
          .find((d) => d._id === selectedDevice)
          .features.includes(f._id) && !f._id.includes("_description")
    );
    const aggregated = calculateAggregatedKPI(
      measurementsRes.docs,
      devices,
      selectedDevice,
      deviceFeatures
    );
    const _tableRows = [];
    aggregated.forEach((a) => {
      const _rows = a.maxs.map((v, i) => {
        return {
          device: a.device,
          feature: a.feature,
          techRQs: a.techRQs,
          techKpi: a.techKpi[i],
          techLoggingReqs: a.techLoggingReqs[i],
          kpiIndex: a.kpiIndex,
          kpiSubIndex: i,
          //max: a.maxs[i],
          //min: a.mins[i],
          mean: a.means[i],
          //std: a.stds[i],
        };
      });

      _tableRows.push(_rows);
    });
    setTableRows(_tableRows.flat());
  };

  return (
    <div className="page">
      <header className="page-header">View Aggregated KPIs</header>
      <main className="page-content">
        <Container fluid>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={3}>
              {deviceNames !== null ? (
                <Form.Select
                  ref={deviceSelectRef}
                  onChange={(e) => {
                    e.preventDefault();
                    handleSelectChange();
                  }}
                >
                  <option>Select Group</option>
                  {React.Children.toArray(
                    deviceNames.map((e) => {
                      return <option value={e}>{ReplaceUnderscores(e)}</option>;
                    })
                  )}
                </Form.Select>
              ) : (
                "Loading"
              )}
            </Col>
          </Row>
          {tableRows !== null ? (
            <KpiTable tableRows={tableRows} />
          ) : (
            "Select a group to show aggregated KPIs"
          )}
        </Container>
      </main>
    </div>
  );
}

function KpiTable({ tableRows }) {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const openPopup = (e, row) => {
    e.preventDefault();
    setPopupData(row);
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  if (tableRows.length === 0)
    return (
      <Row>
        <Col sm={3}>There are no consolidated KPI for this Group</Col>
      </Row>
    );

  return (
    <React.Fragment>
      <Row style={{ paddingTop: 20 + "px" }}>
        <Col sm={12}>
          <div
            style={{
              height: 30 + "vh",
              minHeight: 300 + "px",
              width: 100 + "%",
              overflow: "scroll",
            }}
          >
            <Table striped bordered hover size="lg">
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>Group</th>
                  <th style={{ width: "20%" }}>Tech RQs</th>
                  <th style={{ width: "20%" }}>Tech Logging Requirements</th>
                  <th style={{ width: "10%" }}>ID - Tech KPIs</th>
                  <th style={{ width: "5%" }}>KPI Mean value</th>
                  <th style={{ width: "5%" }}>Manage KPIs</th>
                  {/*<th style={{ width: "5%" }}>KPI's Min value</th>
                  <th style={{ width: "5%" }}>KPI's Max value</th>*/}
                  {/*<th style={{ width: "5%" }}>KPI's Std dev</th>*/}
                </tr>
              </thead>
              <tbody>
                {React.Children.toArray(
                  tableRows.map((r, i) => {
                    return (
                      <tr>
                        <td>
                          {i !== 0 && r.kpiIndex === tableRows[i - 1].kpiIndex
                            ? " "
                            : ReplaceUnderscores(r.device)}
                        </td>
                        <td>
                          {i !== 0 && r.kpiIndex === tableRows[i - 1].kpiIndex
                            ? " "
                            : r.techRQs}
                        </td>
                        <td>
                          {i !== 0 && r.kpiIndex === tableRows[i - 1].kpiIndex
                            ? " "
                            : r.techLoggingReqs}
                        </td>
                        <td>
                          {r.kpiIndex} [{r.kpiSubIndex}] -{" "}
                          {ReplaceUnderscores(r.techKpi)}
                        </td>
                        <td>{Number(r.mean.toFixed(2))}</td>
                        <td>
                          {i !== 0 &&
                          r.kpiIndex === tableRows[i - 1].kpiIndex ? (
                            " "
                          ) : (
                            <Button
                              variant="outline-primary"
                              style={{
                                pointerEvents: "all",
                                border: "none",
                                width: 50 + "px",
                                height: 40 + "px",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              onClick={(e) => openPopup(e, r)}
                            >
                              <i
                                key={"icon"}
                                className="fa fa-magnifying-glass"
                                aria-hidden="true"
                                style={{
                                  width: 30 + "px",
                                  height: 30 + "px",
                                  opacity: 0.85,
                                }}
                              />
                            </Button>
                          )}
                        </td>
                        {/* <td>{Number(r.min.toFixed(2))}</td>
                        <td>{Number(r.max.toFixed(2))}</td>
                        
                        <td>{Number(r.std.toFixed(2))}</td>*/}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
            <Popup
              isOpen={isPopupOpen}
              onClose={closePopup}
              popupData={popupData}
            ></Popup>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}

function Popup({ isOpen, onClose, popupData }) {
  const [enablersKPIs, setEnablersKPIs] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(".popup-content")) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    const fetchdata = async () => {
      if (popupData === undefined || popupData === null) return;

      const response = await get_generic("measurements", {
        limit: -1,
        filter: JSON.stringify({
          device: popupData.device,
          feature: popupData.feature,
        }),
      });
      const responseDesc = await get_generic("measurements", {
        limit: -1,
        filter: JSON.stringify({
          device: popupData.device,
          feature: popupData.feature + "_description",
        }),
      });
      const KPIs = response.docs.map((e) => {
        return {
          ...e,
          descriptionId: responseDesc.docs.find(
            (d) =>
              d.thing === e.thing &&
              d.device === e.device &&
              d.feature === e.feature + "_description"
          )._id,
        };
      });

      setEnablersKPIs(KPIs);
    };
    fetchdata();
  }, [isOpen, popupData]);

  const handleReject = async (id, descId) => {
    const confirm = window.confirm("The KPI will be rejected, proceed?");
    if (confirm === false) return;
    else {
      try {
        await put_generic(
          "measurements",
          {
            stage: "draft",
          },
          id
        );
        await put_generic(
          "measurements",
          {
            stage: "draft",
          },
          descId
        );
      } catch (error) {
        console.error(error);
      }
    }
  };
  const handleAccept = async (id, descId) => {
    const confirm = window.confirm("The KPI will be accepted, proceed?");
    if (confirm === false) return;
    else {
      try {
        await put_generic(
          "measurements",
          {
            stage: "final",
          },
          id
        );
        await put_generic(
          "measurements",
          {
            stage: "final",
          },
          descId
        );
      } catch (error) {
        console.error(error);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: 100 + "%",
        height: 100 + "%",
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(5px)",
        zIndex: 9,
      }}
    >
      <div
        className="page-content"
        style={{
          position: "absolute",
          right: "10%",
          top: "10%",
          border: "2px black solid",
          borderRadius: "10px",
          padding: "10px",
          width: "80%",
          height: "80%",
          zIndex: 11,
        }}
      >
        <div className="popup-content">
          <Table striped bordered hover size="lg">
            <thead>
              <tr>
                <th>KPI value</th>
                <th>De-consolidate</th>
                <th>Accept</th>
              </tr>
            </thead>
            <tbody>
              {React.Children.toArray(
                enablersKPIs !== null ? (
                  enablersKPIs.map((e) => {
                    return (
                      <tr>
                        <td>{e?.samples[0]?.values.join(" - ")}</td>
                        <td>
                          <React.Fragment>
                            <OverlayTrigger
                              overlay={
                                <Tooltip id="reject">
                                  De-consolidate KPI
                                </Tooltip>
                              }
                              placement="top"
                              delayShow={300}
                              delayHide={150}
                            >
                              <Button
                                variant="outline-danger"
                                style={{
                                  pointerEvents: "all",
                                  border: "none",
                                  width: 50 + "px",
                                  height: 40 + "px",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  handleReject(e._id, e.descriptionId);
                                }}
                              >
                                <i
                                  key={"icon"}
                                  className="fa fa-ban"
                                  aria-hidden="true"
                                  style={{
                                    width: 30 + "px",
                                    height: 30 + "px",
                                    opacity: 0.85,
                                  }}
                                />
                              </Button>
                            </OverlayTrigger>
                          </React.Fragment>
                        </td>
                        <td>
                          <React.Fragment>
                            <OverlayTrigger
                              overlay={
                                <Tooltip id="accept">Accept KPI</Tooltip>
                              }
                              placement="top"
                              delayShow={300}
                              delayHide={150}
                            >
                              <Button
                                variant="outline-success"
                                style={{
                                  pointerEvents: "all",
                                  border: "none",
                                  width: 50 + "px",
                                  height: 40 + "px",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  handleAccept(e._id, e.descriptionId);
                                }}
                              >
                                <i
                                  key={"icon"}
                                  className="fa fa-check"
                                  aria-hidden="true"
                                  style={{
                                    width: 30 + "px",
                                    height: 30 + "px",
                                    opacity: 0.85,
                                  }}
                                />
                              </Button>
                            </OverlayTrigger>
                          </React.Fragment>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td>Loading</td>
                  </tr>
                )
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
